




























































































import { Container, Draggable } from './../../../common/vue-smooth-dnd/index';
import { defineComponent, PropType, toRefs, computed, onMounted } from '@vue/composition-api';
import PlaceholderPNG from '@tt4b/ttam-assets/src/images/img-failed.png';
import { ProductListItemType } from '../types';
import { trackEvent } from './../../../../utils/index';
import { ACTION_TYPE, AdgroupFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { useCreativeActionTypeIs, usePreviewProduct } from '@tt4b/ttam-hooks';

const name = 'ttam-products-list';

export default defineComponent({
  name,
  components: {
    Container,
    Draggable,
  },
  props: {
    dataSource: {
      type: Array as PropType<ProductListItemType[]>,
      default: () => [],
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
    disableDrag: {
      type: Boolean,
      default: false,
    },
    dragShowKey: {
      type: String,
      default: '',
    },
    dragClickKey: {
      type: String,
      default: '',
    },
    removeClickKey: {
      type: String,
      default: '',
    },
    idText: {
      type: String,
      default: 'ID',
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: false,
      default: () => ({} as FullNormalFormData),
    },
  },
  setup(props, { emit }) {
    const { dataSource, disableDelete, createMode, adgroupData, idText, disableDrag, creativeData } = toRefs(props);
    const { isEdit } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });
    const disabledProducts = computed(() => dataSource.value?.filter?.(item => item.disabled));
    const { changeSelectedProduct, previewProduct } = usePreviewProduct({
      creativeFormData: creativeData,
    });

    const handleClickItem = (item?: ProductListItemType) => {
      // 禁用拖拽时，才响应点击事件
      if (disableDrag.value) {
        if (!item) {
          // 删除选定的商品 场景
          changeSelectedProduct();
        } else if (!item?.disabled) {
          changeSelectedProduct(item);
        }
      }
    };

    const onDrop = (dropResult: { removedIndex: number; addedIndex: number }) => {
      const { removedIndex, addedIndex } = dropResult;
      const curArr = [...dataSource.value];
      const removedItem = curArr.splice(removedIndex, 1);
      curArr.splice(addedIndex, 0, ...removedItem);

      emit('change', curArr);
    };

    const onRemove = (idx: number, event) => {
      if (!disableDelete.value) {
        const curArr = [...dataSource.value];
        curArr.splice(idx, 1);
        emit('remove', idx);
        emit('change', curArr);
        handleClickItem();
        event?.preventDefault();
        event?.stopPropagation();
      }
    };

    const ProductItemInDesc = computed(() => item => {
      if (item.id) {
        return `${idText.value}: ${item.id}`;
      } else {
        return '';
      }
    });

    const onDragStart = () => {
      if (props.dragClickKey) {
        trackEvent(props.dragClickKey);
      }
    };

    onMounted(() => {
      if (props.dragShowKey) {
        trackEvent(props.dragShowKey);
      }
    });

    return {
      name,
      PlaceholderPNG,
      disabledProducts,
      isEdit,
      ProductItemInDesc,
      onDrop,
      onRemove,
      onDragStart,
      handleClickItem,
      previewProduct,
    };
  },
});
